import type { RoomListItem } from '@/shared/types/app'

import type { ChatFolder } from '../types/chat-folder'

import { ALL_CHATS_FOLDER_ID } from './constants'

export const filterRoomsByFolder = (
  rooms: RoomListItem[],
  folderId: string,
  folders: ChatFolder[],
): RoomListItem[] => {
  if (folderId === ALL_CHATS_FOLDER_ID) {
    return rooms
  }

  const folder = folders.find((item) => item.id === folderId)
  if (!folder) {
    return rooms
  }

  const allowed = new Set(folder.pServeds)
  return rooms.filter((room) => allowed.has(room.pServedUser))
}
